import { render, staticRenderFns } from "./cProtocol.vue?vue&type=template&id=87edd810&scoped=true&lang=pug"
import script from "./cProtocol.vue?vue&type=script&lang=js"
export * from "./cProtocol.vue?vue&type=script&lang=js"
import style0 from "./cProtocol.vue?vue&type=style&index=0&id=87edd810&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87edd810",
  null
  
)

export default component.exports